import { Injectable, OnInit } from '@angular/core';
import { PlanogramService } from './planogram.service';
import { ProductOverride } from "../models/product-override";
import { PlanogramOptions } from "../models/planogram-options";
import { ProductReference } from "../models/layout/product-reference";
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProductOverrideService {
    private overrides : Map<number,ProductOverride> = new Map<number,ProductOverride>();
    public overrideChanged = new Subject<void>();

	constructor(private planogramService: PlanogramService){}

    setOverrides(options: PlanogramOptions) {
        this.overrides.clear();
        if(options.overrides.length > 0){
            for(let i = 0; i < options.overrides.length; i++ ){
                this.overrides.set(options.overrides[i].productId, options.overrides[i]);
            }
        }
    }

    getOverrides() : ProductOverride[] {
        let overrides = Array.from(this.overrides.values());
        return overrides;
    }

    getOverride(productId: number) : ProductOverride | undefined {
        return this.overrides.get(productId);
    }

    setOverride(productId: number, override: ProductOverride) : void {
        this.overrides.set(productId, override);
        this.overrideChanged.next();
    }

    clearOverride(productId: number) {
        this.overrides.delete(productId);
        this.overrideChanged.next();
    }
    
    isProductEnabled(productId: number) {
        const override = this.overrides.get(productId);
        // If there's no override at all, return true
        if (!override) return true;
        // If there is an override, use its enabled value, defaulting to true if null/undefined
        return override.enabled ?? true;
    }

    toggleProductEnabled(productId: number, enabled: boolean) {
        const existingOverride = this.overrides.get(productId);
        if (existingOverride) {
            // Update existing override
            existingOverride.enabled = enabled;
            this.overrides.set(productId, existingOverride);
        } else {
            // Create new override with just the enabled state
            const newOverride = new ProductOverride(productId, enabled, null, null, null, null, null, null, null);
            this.overrides.set(productId, newOverride);
        }
        this.overrideChanged.next();
    }
}